import { analyticsEventTypes } from 'events/analytics';
import {
  WIDGET_OPENED_TRIGGER_API,
  WIDGET_OPENED_TRIGGER_MANUAL,
  WIDGET_OPENED_TRIGGER_PROACTIVE_RULE,
} from 'actions/ui/unminimizeWidget';
import { WIDGET_OPENED_EVENT, WIDGET_OPENED_TRIGGER } from 'GladlySidekickConstants';

export default function widgetOpened() {
  return {
    [analyticsEventTypes.WIDGET_OPENED]: ({ payload: { trigger } }) => {
      return [
        {
          eventName: WIDGET_OPENED_EVENT,
          eventPayload: [
            {
              source: mapWidgetOpenedTrigger(trigger),
            },
          ],
        },
      ];
    },
  };
}

function mapWidgetOpenedTrigger(trigger) {
  switch (trigger) {
    case WIDGET_OPENED_TRIGGER_API:
      return WIDGET_OPENED_TRIGGER.API;
    case WIDGET_OPENED_TRIGGER_MANUAL:
      return WIDGET_OPENED_TRIGGER.BUTTON;
    case WIDGET_OPENED_TRIGGER_PROACTIVE_RULE:
      return WIDGET_OPENED_TRIGGER.PROACTIVE_RULE;
  }

  return '';
}
